import { Controller } from "@hotwired/stimulus"

// Show/hide season date range based on "All Year" vs "Date Range" radio selection
export default class extends Controller {
  static targets = ["dateRange", "allYearRadio"]

  connect() {
    this.toggle()
  }

  toggle() {
    const allYear = this.hasAllYearRadioTarget && this.allYearRadioTarget.checked
    this.dateRangeTarget.classList.toggle("hidden", allYear)

    if (allYear) {
      this.dateRangeTarget.querySelectorAll("[data-controller~='custom-select']").forEach(el => {
        const controller = this.application.getControllerForElementAndIdentifier(el, "custom-select")
        if (controller) controller.clear()
      })
    }
  }
}
